var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 15.625H31.25V31.25H15.625V15.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 0V46.875H0V0H46.875ZM39.0625 7.8125H7.8125V39.0625H39.0625V7.8125ZM31.25 93.75H15.625V109.375H31.25V93.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 78.125V125H0V78.125H46.875ZM7.8125 85.9375V117.188H39.0625V85.9375H7.8125ZM93.75 15.625H109.375V31.25H93.75V15.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.125 0V46.875H125V0H78.125ZM117.188 7.8125V39.0625H85.9375V7.8125H117.188ZM62.5 7.8125V0H70.3125V15.625H62.5V31.25H54.6875V7.8125H62.5ZM62.5 46.875V31.25H70.3125V46.875H62.5ZM46.875 62.5V54.6875H54.6875V46.875H62.5V62.5H70.3125V54.6875H109.375V62.5H78.125V70.3125H54.6875V62.5H46.875ZM46.875 62.5V70.3125H15.625V62.5H7.8125V70.3125H0V54.6875H23.4375V62.5H46.875ZM125 70.3125H117.188V54.6875H125V70.3125ZM117.188 70.3125H109.375V85.9375H125V78.125H117.188V70.3125ZM85.9375 70.3125H101.562V78.125H93.75V85.9375H85.9375V70.3125ZM101.562 93.75V85.9375H93.75V93.75H85.9375V101.562H70.3125V109.375H93.75V93.75H101.562ZM101.562 93.75H125V101.562H109.375V109.375H101.562V93.75ZM70.3125 85.9375V93.75H78.125V78.125H54.6875V85.9375H70.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 93.75H62.5V117.188H93.75V125H54.6875V93.75ZM125 109.375V125H101.562V117.188H117.188V109.375H125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/qr-scan.079b59abab1308e81f67c39b322955d6.svg";
export { ForwardRef as ReactComponent };